import { Trans } from '@lingui/react';
import { GqlMeetingKind } from '../../../graphql/base-types.graphql';

export const MeetingKindHuman = ({ children }: { children: GqlMeetingKind }) => {
  switch (children) {
    case GqlMeetingKind.ExtraShareholdersMeeting: {
      return <Trans id="Extra general meeting" />;
    }
    case GqlMeetingKind.ShareholdersMeeting: {
      return <Trans id="Annual general meeting" />;
    }
    case GqlMeetingKind.BoardMeeting: {
      return <Trans id="Board meeting" />;
    }
    default: {
      throw new Error(`missing gql meeting kind ${children}`);
    }
  }
};
